var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSadFace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon/sad-face") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M15,4 C21.0751322,4 26,8.92486775 26,15 C26,21.0751322 21.0751322,26 15,26 C8.92486775,26 4,21.0751322 4,15 C4,8.92486775 8.92486775,4 15,4 Z M15,6 C10.0294373,6 6,10.0294373 6,15 C6,19.9705627 10.0294373,24 15,24 C19.9705627,24 24,19.9705627 24,15 C24,10.0294373 19.9705627,6 15,6 Z M15,16 C16.3247669,16 17.5068925,16.4503336 18.5256717,17.1912639 C19.1309689,17.63148 19.5571182,18.0761576 19.8,18.4 C20.1313708,18.8418278 20.0418278,19.4686292 19.6,19.8 C19.1581722,20.1313708 18.5313708,20.0418278 18.2,19.6 C18.0678818,19.4238424 17.7752811,19.11852 17.3493283,18.8087361 C16.6493575,18.2996664 15.8627331,18 15,18 C14.1372669,18 13.3506425,18.2996664 12.6506717,18.8087361 C12.2247189,19.11852 11.9321182,19.4238424 11.8,19.6 C11.4686292,20.0418278 10.8418278,20.1313708 10.4,19.8 C9.9581722,19.4686292 9.86862915,18.8418278 10.2,18.4 C10.4428818,18.0761576 10.8690311,17.63148 11.4743283,17.1912639 C12.4931075,16.4503336 13.6752331,16 15,16 Z M12.01,11 C12.5622847,11 13.01,11.4477153 13.01,12 C13.01,12.5128358 12.6239598,12.9355072 12.1266211,12.9932723 L12,13 C11.4477153,13 11,12.5522847 11,12 C11,11.4871642 11.3860402,11.0644928 11.8833789,11.0067277 L12.01,11 Z M18.01,11 C18.5622847,11 19.01,11.4477153 19.01,12 C19.01,12.5128358 18.6239598,12.9355072 18.1266211,12.9932723 L18.01,13 C17.4477153,13 17,12.5522847 17,12 C17,11.4871642 17.3860402,11.0644928 17.8833789,11.0067277 L18.01,11 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/sad-face",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#000000",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "colour/black",
    mask: "url(#mask-2)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 30,
    height: 30
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSadFace);
export default __webpack_public_path__ + "static/media/sad-face.5f995774b24d7bbaba09a645281ea6dd.svg";
export { ForwardRef as ReactComponent };